<template>
  <div class="login-form_wrapper">
    <h1 class="login-form-header">
      Войдите в ваш <br />Snedson
      Account
    </h1>

    <div class="demo-access">
      <div class="demo-access-head">
        <span class="demo-access-badge">Демонстрационные аккаунты</span>
        <p class="demo-access-hint">
          Нажмите на аккаунт, чтобы выполнить вход
        </p>
      </div>

      <div class="demo-access-roles">
        <button
          type="button"
          class="demo-role"
          @click="fillForm('SVasilieva', 'IUHKJDNklmdsfkls2354!')"
        >
          <div class="demo-role-avatar" aria-hidden="true">
            <img class="demo-role-avatar-icon" src="@/img/icons/teacher.png" />
          </div>
          <span class="demo-role-body">
            <span class="demo-role-title"
              >Учитель</span
            >
            <span class="demo-role-creds">
              <b>SVasilieva</b>
              <span class="demo-role-dot">•</span>
              password
            </span>
          </span>
          <span class="demo-role-arrow" aria-hidden="true">→</span>
        </button>

        <button
          type="button"
          class="demo-role"
          @click="fillForm('MKotowsky', 'IUHKJDNklmdsfkls2354!')"
        >
          <span class="demo-role-avatar" aria-hidden="true">
            <img class="demo-role-avatar-icon" src="@/img/icons/student.png" />
          </span>
          <span class="demo-role-body">
            <span class="demo-role-title"
              >Ученик</span
            >
            <span class="demo-role-creds">
              <b>MKotowsky</b>
              <span class="demo-role-dot">•</span>
              password
            </span>
          </span>
          <span class="demo-role-arrow" aria-hidden="true">→</span>
        </button>
      </div>
    </div>

    <form class="login-form" @submit.prevent>
      <mcw-textfield
        class="login-form-login-input"
        type="text"
        v-model="form.login"
        label="Ваш логин"
        @change="form.errorText = ''"
        outline
        required
        fullwidth
      />

      <mcw-textfield
        class="login-form-password-input"
        type="password"
        v-model="form.password"
        label="Ваш пароль"
        @change="form.errorText = ''"
        outline
        required
        fullwidth
      />

      <smdc-card
        v-if="form.errorText != ''"
        background-color="#FFFFFF"
        border-color="#B00020"
      >
        <p class="login-form-errors">{{ form.errorText }}</p>
      </smdc-card>

      <div class="login-form-submit">
        <p class="login-form-submit-switch-form">
          Нет аккаунта? <a>Регистрация</a>
        </p>

        <mcw-button
          class="login-form-submit-button"
          @click="$emit('submitLogin')"
          raised
        >
          Войти
        </mcw-button>
      </div>

      <div class="login-redirect-info_wrapper">
        <img class="login-redirect-info-icon" src="@/img/SnotraLogo.png" />
        <p class="login-redirect-info-text">
          После авторизации вы попадете на сайт Snotra вашей школы
        </p>
      </div>
    </form>
  </div>
</template>

<script setup>
import { onMounted, onBeforeMount, onActivated, reactive, toRefs } from "vue";
import smdcCard from "@/components/materialComponents/smdcCard.vue";

const emit = defineEmits(['submitLogin']);
const props = defineProps({
  form: Object,
});

const { form } = toRefs(props);

onMounted(() => {
  mdc.autoInit();
  mdc.textField.MDCTextField.attachTo(
    document.querySelector(".login-form-login-input")
  );
  mdc.textField.MDCTextField.attachTo(
    document.querySelector(".login-form-password-input")
  );
});

const fillForm = (login, password) => {
  form._object.form.login = login;
  form._object.form.password = password;
  emit('submitLogin')
};
</script>

<style lang="scss">
input:-webkit-autofill,
input:-webkit-autofill:hover,
input:-webkit-autofill:focus {
  -webkit-text-fill-color: black;
  transition: background-color 5000s ease-in-out 0s;
}

.login-form-login-input,
.login-form-password-input,
.custom-outlined-button,
.mdc-floating-label,
.login-form-submit-button,
.customFloatLabel {
  --mdc-theme-primary: #f30007;
  --mdc-floating-label: #000000;
}

.mdc-text-field__input {
  width: 100%;
}

.login {
  &-form {
    display: flex;
    flex-direction: column;
    gap: 20px;
    margin-top: 24px;

    &-header {
      margin: 0;
      text-align: left;
      color: #000000;
      &_your {
        background-color: #f30007;
        color: #ffffff;
        border-radius: 5px;
        padding: 2px 10px;
      }
    }

    &-login-input,
    &-password-input,
    .mdc-textfield {
      width: 100%;
    }

    &-submit {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;

      &-switch-form {
        word-break: break-all;
        overflow-wrap: break-word;
        & a {
          cursor: pointer;
        }
      }
    }

    &-errors {
      margin: 0;
      text-align: left;
      color: #f30007;
      word-break: break-word;
      overflow-wrap: break-word;
    }
  }

  &-redirect-info {
    &_wrapper {
      width: 100%;
      height: 100%;
      display: flex;
      flex-direction: row;
      align-items: center;
      gap: 10px;
      margin-top: 20px;
    }
    &-icon {
      width: 60px;
      height: 60px;
      border-radius: 10px;
    }

    &-text {
      font-size: 17px;
    }
  }
}

.mdc-floating-label {
  -webkit-text-fill-color: black;
}

/* ---------- DEMO ACCESS PANEL ---------- */
.demo-access {
  margin-top: 20px;
  padding: 16px;
  border-radius: 14px;
  background: #fff6f6;
  border: 1.5px solid #f8c6ca;

  &-head {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 10px;
    margin-bottom: 14px;
  }

  &-badge {
    margin: 0 auto;
    flex: none;
    background: #f30007;
    color: #ffffff;
    font-size: 12px;
    font-weight: 700;
    letter-spacing: 0.04em;
    text-transform: uppercase;
    padding: 5px 10px;
    border-radius: 999px;
  }

  &-hint {
    margin: 0 auto;
    font-size: 15px;
    color: #5c5c5c;
  }

  &-roles {
    display: flex;
    flex-direction: column;
    gap: 10px;
  }
}

.demo-role {
  display: flex;
  align-items: center;
  gap: 12px;
  width: 100%;
  padding: 12px 14px;
  background: #ffffff;
  border: 1.5px solid #f0d3d4;
  border-radius: 12px;
  cursor: pointer;
  text-align: left;
  font-family: inherit;
  transition: border-color 0.15s ease, background 0.15s ease,
    transform 0.15s ease;

  &:hover,
  &:focus-visible {
    border-color: #f30007;
    background: #fffafa;
    transform: translateY(-1px);
    outline: none;
  }

  &:active {
    transform: translateY(0);
  }

  &-avatar {
    flex: none;
    width: 40px;
    height: 40px;
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: 700;
    font-size: 15px;
    &-icon {
      width: 40px;
      height: 40px;
    }
  }

  &-body {
    flex: 1;
    min-width: 0;
    display: flex;
    flex-direction: column;
    gap: 4px;
  }

  &-title {
    font-size: 14px;
    font-weight: 700;
    color: #000000;

    i {
      font-style: normal;
      font-weight: 500;
      color: #7a7a7a;
    }
  }

  &-creds {
    font-family: "Courier New", monospace;
    font-size: 13px;
    color: #444444;
    display: flex;
    align-items: center;
    gap: 6px;
    word-break: break-all;
  }

  &-dot {
    color: #cccccc;
  }

  &-arrow {
    flex: none;
    color: #f30007;
    font-size: 18px;
    opacity: 0.7;
    font-weight: 800;
  }
}

@media (min-width: 560px) {
  .demo-access-roles {
    flex-direction: column;
  }

  .demo-role {
    flex: 1 1 0;
  }
}

@media (max-width: 380px) {
  .demo-role-creds {
    font-size: 12px;
  }
}
</style>